import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    color: "#FFFFFF",
    alignItems: "center",
  },
  iconStyle: {
    color: "#1E49E2",
    Width: "25px",
    height: "25px",
    fontSize: "25px",
    marginRight: "10px;",
    "& .MuiBadge-badge": {
      backgroundColor: "#eb004d",
    },
  },
  anchorTopRight: {
    transform: "translate(35%, -35%)",
    height: "17px",
  },
  menuButton: {
    color: "inherit",
    textTransform: "none",
    [theme.breakpoints.down("md")]: {
      "& .MuiButton-endIcon": {
        marginLeft: 0,
      },
    },
    "&:hover": {
      outline: "2px solid white",
    },
    "&.Mui-focusVisible": {
      outline: "2px solid white",
    },
  },
  MobileBadgeStyle: {
    marginRight: "15px",
    "& .MuiBadge-dot": {
      backgroundColor: "#eb004d",
    },
  },
  MobileNotificationIcon: {
    marginRight: "-5px !important",
    marginTop: "-5px",
  },
  profileMenu: {
    fontFamily: "Open Sans",
    fontSize: "12px",
    lineHeight: "22px",
    color: "#1E49E2",
    padding: "15px",
    borderRadius: "12px",
    minWidth: "189.33px",
    [theme.breakpoints.down(700)]: {
      lineHeight: "0px",
    },
  },
  menuStyle: {
    padding: "0px",
    cursor: "pointer",
    [theme.breakpoints.down(700)]: {
      minHeight: "0px",
      lineHeight: "0px",
      paddingTop: "0px",
      paddingLeft: "6px",
    },
    "&:hover": {
      outline: "auto",
    },
  },
  topDivider: {
    margin: "5px 0px 12px 0px",
  },
  paperBorder: {
    borderRadius: "12px",
  },
  liButton: {
    color: "#1E49E2",
    textTransform: "none",
    fontSize: "1rem",
    width: "100%",
    justifyContent: "left",
  },
  focus: {
    outline: "2px solid #1E49E2",
  },
}));
